/**
 * @module views\sys\menu\menuConfig
 */
import Component from "vue-class-component";
import { Prop, Mixins, Watch } from "vue-property-decorator";
import GhClassService from "@/utils/mixins/clsService";
import TableColumn from "@/components/ghTable/dataTable/tableColumn/tableColumn.vue";
import { MethodService } from "@/utils/serviceModel";
import GhCodeEditor from "@/components/ghCodeEditor/ghCodeEditor";

@Component({
  components: {
    TableColumn
  }
})
export default class MenuConfig extends Mixins(GhClassService) {
  /**
   * 界面配置
   */
  private options = {
    page_id: null, // 选择的页面
    db: "", // 数据库
    table: "", // 表
    tableId: "", // 表Id
    code: "", // 服务代码
    tableDemo: "", // 备注
    pageCode: "" // 页面代码
  };

  /**
   * 菜单
   */
  private menu: IndexObject = {};

  /**
   * 步骤
   */
  private step = 1;

  mounted() {
    this.invoke("get_dynamic_pages");
    this.invoke("get_db_list");
  }

  /**
   * 导航到该界面时
   * @param parames
   */

  protected onNavigateTo(parames) {
    this.step = 1;
    this.options = Object.assign({}, this.optionsTemplate);
    if (parames) {
      this.menu = parames;
      if (this.menu.options) {
        let option: IndexObject | null = this.menu.options;
        if (option) {
          Object.assign(this.options, option);
          this.intialOptions(this.menu.Id, option);
        }
      }
    }
  }

  /**
   * 根据菜单初始化相关数据(table,code等)
   * @param id
   * @param options
   */
  private async intialOptions(id, options) {
    let res = await this.invoke("get_options", { id, options });
    if (res) {
      if (res.data.isSuccess) {
        Object.assign(this.options, res.data.data);
      }
    }

    // this.options = { ...this.options, ...options };
  }

  /**
   * 创建数据库
   */
  private async createTable() {
    if (await this.$validator.validateAll()) {
      try {
        this.$setLoading(true);
        let res = await this.invoke("create_table", {
          db: this.options.db,
          table: this.options.table,
          demo: this.options.tableDemo
        });
        if (res) {
          if (res.data.isSuccess) {
            this.options.tableId = res.data.data;
            this.next();
          }
        }
      } catch (error) {
      } finally {
        this.$setLoading(false);
      }
    }
  }

  /**
   * 数据库验证通过后，下一步
   */
  private async validateTableNext() {
    if (await this.$validator.validateAll()) {
      this.next();
    }
  }

  /**
   * 生成后端服务代码
   */
  private async generateServiceCode() {
    this.$setLoading(true);
    try {
      let res = await this.invoke("generate_service_code", {
        options: this.options
      });
      if (res) {
        if (res.data.isSuccess) {
          this.options.code = res.data.data;
        }
      }
    } catch (error) {
    } finally {
      this.$setLoading(false);
    }
  }

  private submitCode(ref: string) {
    let editor = this.$refs[ref] as GhCodeEditor;
    if (editor) {
      editor.submit();
      this.next();
    }
  }

  /**
   * 生成前端页面代码
   */
  private async generatePageCode() {
    try {
      this.$setLoading(true);
      let res = await this.invoke("generate_page_code", {
        menu_id: this.menu.Id,
        options: this.options
      });
      if (res) {
        if (res.data.isSuccess) {
          this.options.pageCode = res.data.data;
        }
      }
    } catch (error) {
    } finally {
      this.$setLoading(false);
    }
  }

  /**
   * 保存配置
   */
  private async save() {
    try {
      this.$setLoading(true);
      let res = await this.invoke("save_menu", {
        menu: this.menu,
        options: this.options
      });
    } catch (error) {
    } finally {
      this.$setLoading(false);
    }
  }

  /**
   * 前进
   */
  private next() {
    this.step += 1;
  }
  /**
   * 后台
   */
  private back() {
    this.step -= 1;
  }

  /**
   * 返回菜单维护界面
   */
  private retureMenuPage() {
    this.navigate("/sys01");
  }

  private steps = [
    {
      step: 1,
      title: "选择页面类型"
    },
    {
      step: 2,
      title: "建立数据库"
    },
    {
      step: 3,
      title: "配置表结构"
    },
    {
      step: 4,
      title: "编写后台脚本"
    },
    {
      step: 5,
      title: "编写前台脚本"
    },
    {
      step: 6,
      title: "完成配置"
    }
  ];

  private get selectedPage() {
    let res: any = null;
    if (this.options.page_id) {
      if (this.serviceMethods.get_dynamic_pages) {
        let method = this.serviceMethods.get_dynamic_pages as MethodService;
        if (method.data) {
          if (Array.isArray(method.data)) {
            let array = method.data as IndexObject[];
            res = array.find(item => item.Id === this.options.page_id);
          }
        }
      }
    }
    if (!res) {
      res = {};
    }
    return res;
  }

  private codeOptions = {
    readOnly: false,
    language: "python",
    autoIndent: true,
    automaticLayout: true
  };

  private jsCodeOptions = {
    readOnly: false,
    language: "javascript",
    autoIndent: true,
    automaticLayout: true
  };

  protected module = "mes.business.sys.service";
  protected cls = "DynamicMenuService";
  protected serviceMethods: { [key: string]: MethodService | null } = {
    get_db_list: null,
    table_exist: null,
    create_model: null,
    create_table: null,
    create_source: null,
    get_dynamic_pages: null,
    save_menu: null,
    get_options: null,
    generate_service_code: null,
    generate_page_code: null
  };
  private optionsTemplate = {
    page_id: null, // 选择的页面
    db: "", // 数据库
    table: "", // 表
    tableId: "", // 表Id
    code: "", // 服务代码
    tableDemo: "", // 备注
    pageCode: "" // 页面代码
  };
}
